<template>
    <div>
      <FilterTable 
        :resource_name="resource_name"
        :title="title"
        :field_definitions="field_definitions"
        :filters="{}"
        :action_buttons="action_buttons"
        :row_actions="row_actions"
        :translate_to_display_data="translate_to_display_data"
        :route_root="route_root"
        :handle_row_action="handle_row_action"
        :full_text_search="false"
        :handle_action_button_click="handle_action_button_click"
        :update_flag="filter_table_update_flag"
      />
      <LoadingBlock
          :active="loading">
      </LoadingBlock>
    </div>
</template>

<script>
import breadcrumbMixin from '@/mixins/breadcrumbMixin'
import FilterTable from '@/components/backstage/FilterTable/FilterTable.vue'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import api from '@/api/index'

export default {
  mixins: [breadcrumbMixin],
  components: {
    FilterTable,
    LoadingBlock
  },
  created() {
    this.permission_check({
      resource_info: { name: this.page_name.PAGE_FREQUENTLY_ASKED_QUESTION_MANAGEMENT },
      access: { name: this.permission.VIEW },
      reject: { action: this.permission.REJECT_REDIRECT, path: '/dashboard' }
    })
  },
  data() {
    return {
      resource_name: 'frequently-asked-question',
      title: '常見問題Q&A管理',
      route_root: 'front-stage-management/frequently-asked-question-management',
      field_definitions: [
        {
          display: {
            name: '序號',
            type: 'string',
            sortable: 'custom',
          },
          source: {
            type: 'db',
            key: 'id',
            data_type: 'string',
          } 
        },
        {
          display: {
            name: '提問',
            type: 'string',
            sortable: 'custom',
          },
          source: {
            type: 'db',
            key: 'question',
            data_type: 'string',
          } 
        },
        {
          display: {
            name: '回答',
            type: 'string',
            sortable: 'custom',
          },
          source: {
            type: 'db',
            key: 'answer',
            data_type: 'string',
          }
        },
        {
          display: {
            name: '最後更新日期',
            type: 'string',
            sortable: 'custom',
          },
          source: {
            type: 'db',
            key: 'updated_time',
            data_type: 'datetime',
          }
        },
      ],
      action_buttons: {
        add: {
          label: '新增常見問題',
          action: 'add'
        },
      },
      row_actions: {
        // get: {
        //   label: '檢視',
        //   action: 'get'
        // },
        edit: {
          label: '編輯',
          action: 'edit',
        },
        // suspend: {
        //   label: '凍結',
        //   action: 'suspend',
        //   enable: (row) => (row['status'] === '開通') && this.check_row(this.permission.SUSPEND, row)
        // },
        // resume: {
        //   label: '復原',
        //   action: 'resume',
        //   enable: (row) => (row['status'] !== '開通') && this.check_row(this.permission.RESUME, row)
        // },
        delete: {
          label: '刪除',
          action: 'delete',
        },
      },
      loading: false,
      filter_table_update_flag: 0
    }
  },
  methods: {
      translate_to_display_data(data) {
        console.log('translate_to_display_data')

        let types = {}
        this.field_definitions.forEach(
          function (field) {
            types[field['source']['key']] = field['source']['data_type']
          })

        let translated_data = data
        
        for (let key in data) {
          if (types[key] === 'datetime' && data[key]) {
            translated_data[key] = data[key].date.slice(0,-7)
          }
        }
        
        return translated_data
      },
      handle_row_action (action, index, row) {
        console.log('FrequentlyAskedQuestionManagementPage: action:' + action + ', index: ' + index + ', row: ', row)

        switch(action){
          case 'edit': 
            this.backstage_router_push({ path: `/${this.route_root}/edit/${row.id}` })
            break
          case 'delete': 
            this.$confirm('此操作將刪除該常見問題，是否繼續?', '提示', {
              confirmButtonText: '確定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.handle_delete_faq(row.id).then(
                string => {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                }
              ).catch(
                response => {
                  this.$message({
                    type: 'success',
                    message: '删除失敗，請聯絡系統管理員!'
                  })
                }
              )
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
            break
          default:
            break
        }
      },
      handle_action_button_click (action) {
        console.log('FrequentlyAskedQuestionManagementPage: action button clicked: ', action)

        switch(action){
          case 'add': 
            this.backstage_router_push({ path: `/${this.route_root}/add` })
            break
          default:
            break
        }
      },
      handle_do_update () {
        this.filter_table_update_flag += 1
      },
      async handle_delete_faq(id) {
        console.log('delete faq: id=', id)
        this.loading = true
        await api.delete_faq(id)
        this.loading = false
        this.filter_table_update_flag += 1
      }
    },
};

</script>

<style>
</style>
